// GAVION rep stats: acquisition cost (Settings → Costs, Reports → Costs & CAC). Admins only.
export const costsEn = {
  settings: {
    title: "Costs",
    intro:
      "Rep pay and monthly expenses, used to compute the cost per call, per demo and the customer acquisition cost (CAC). Each row applies from its effective date: history is kept and past months keep their old rates.",
    saved: "Saved",
    deleted: "Deleted",
    delete: "Delete",
    delete_aria: "Delete the row of %{date}",
    add: "Add",
    effective_from: "Effective from",
    history: "History",
    compensation: {
      title: "Pay per rep",
      rep: "Rep",
      pay_type: "Pay type",
      hourly: "Hourly",
      salary: "Monthly salary",
      hourly_rate: "Hourly rate ($/h)",
      monthly_salary: "Monthly salary ($)",
      commission_pct: "Commission (% of won revenue)",
      bonus_per_deal: "Bonus per won deal ($)",
      empty: "No pay entered.",
      summary_hourly: "$%{rate}/h",
      summary_salary: "$%{amount}/month",
      summary_commission: "+ %{pct}% of revenue",
      summary_bonus: "+ $%{amount} per deal",
      hint: "Hourly: paid on calling session time.",
    },
    fixed: {
      title: "Monthly fixed costs",
      category: "Category",
      monthly_amount: "Monthly amount ($)",
      label: "Description (optional)",
      empty: "No fixed cost entered.",
      hint: "A new amount replaces the previous one of the same category from its effective date. Enter 0 to stop a cost.",
    },
    marketing: {
      title: "Monthly marketing spend (optional)",
      channel: "Channel (deal source)",
      empty: "No marketing spend entered.",
    },
    categories: {
      telephony: "Telephony (VoIP.ms, etc.)",
      software: "Software",
      other: "Other",
      marketing: "Marketing",
    },
    basis: {
      title: "Deal amounts",
      label: "A deal amount is",
      unset: "Not set",
      one_time: "A one-time payment",
      monthly: "A monthly amount (subscription)",
      annual: "An annual amount",
      hint: "Used for the payback period: it is only computed for monthly or annual amounts.",
    },
    errors: {
      required: "Required.",
      amount: "Enter an amount between 0 and 1,000,000.",
      pct: "Enter a percentage between 0 and 100.",
      date: "Enter a valid date.",
      duplicate: "A row already exists on that date.",
      save: "Could not save.",
    },
  },
  report: {
    title: "Costs & CAC",
    description:
      "Total cost, cost per call and per demo, customer acquisition cost, per rep and for the team (admins).",
    rep_title: "Costs & CAC (admins)",
    empty: "No costs have been entered: nothing to compute.",
    empty_link: "Enter the costs in Settings → Costs",
    no_compensation:
      "No pay entered for this rep: only their share of fixed costs is counted.",
    team: "Team",
    by_rep: "Per rep",
    by_channel: "Marketing per channel",
    rep: "Rep",
    channel: "Channel",
    spend: "Spend",
    unallocated:
      "%{amount} of fixed costs are not allocated to any rep (no calling session in the period).",
    how: "How it is calculated: %{label}",
    na: "n/a",
    months: "%{value} months",
    ratio: "%{value} ×",
    metrics: {
      total: "Total cost",
      pay: "Pay",
      commission: "Commissions",
      fixed: "Fixed costs",
      fixed_share: "Share of fixed costs",
      marketing: "Marketing",
      cost_per_dial: "Cost per call",
      cost_per_conversation: "Cost per conversation",
      cost_per_demo: "Cost per demo",
      cac: "Customer acquisition cost (CAC)",
      revenue_won: "Revenue won",
      revenue_cost_ratio: "Revenue / cost ratio",
      payback_months: "Payback period",
      marketing_cost_per_deal: "Marketing cost per deal",
      deals_won: "Deals won",
    },
    formulas: {
      total:
        "Pay + commissions + share of fixed costs (+ marketing for the team).",
      pay: "Hourly: session hours × the rate in force that day. Salary: monthly salary ÷ days in the month, for each day of the period.",
      commission:
        "% of won revenue + fixed bonus per won deal, with the pay in force on the sale date.",
      fixed:
        "Telephony, software and other: monthly amount ÷ days in the month, for each day of the period. Split between reps pro rata of their session time.",
      fixed_share:
        "Fixed costs of the period × the rep's session time ÷ the team's session time.",
      marketing:
        "Monthly marketing spend ÷ days in the month, for each day. Counted for the team only.",
      cost_per_dial: "Total cost ÷ calls.",
      cost_per_conversation: "Total cost ÷ conversations.",
      cost_per_demo: "Total cost ÷ demos booked.",
      cac: "Total cost ÷ deals won in the period.",
      revenue_won: "Sum of the amounts of the deals won in the period.",
      revenue_cost_ratio: "Revenue won ÷ total cost.",
      payback_months:
        "CAC ÷ average monthly revenue per won deal (amount ÷ 12 when amounts are annual). n/a when amounts are one-time or not set (Settings → Costs).",
      marketing_cost_per_deal:
        "Channel marketing spend ÷ deals won from that channel in the period. Excludes pay, commissions and fixed costs: this is not the CAC.",
      deals_won: "Non-archived deals moved to « Won » in the period.",
    },
  },
};
